import { render, staticRenderFns } from "./TariffDetail.vue?vue&type=template&id=791dcec5&scoped=true&"
import script from "./TariffDetail.vue?vue&type=script&lang=js&"
export * from "./TariffDetail.vue?vue&type=script&lang=js&"
import style0 from "./TariffDetail.vue?vue&type=style&index=0&id=791dcec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791dcec5",
  null
  
)

export default component.exports